/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Detail_Page_Content_GlobalInputs */

const en_subscription_detail_page_content_global = /** @type {(inputs: Subscription_Detail_Page_Content_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Tree Collection

- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your subscription. (not permanently unlocked)
- Plus Exclusive Trees are strictly reserved for Plus members.
- Seasonal content updates every Dec 31, Mar 31, Jun 30, and Sep 30 (UTC+8), including Seasonal New Trees, and Seasonal Select Crystal Trees.
- All trees can be used in "Plant together."

</div>

<div>

# Plus Advanced Features

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Enjoy Plus Exclusive Trees | - | - | ✔️ |
| Early Access to Seasonal New Trees | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscape | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of subscription status.

</div>

<div>

# Subscription Reminders

### Trial Period Details
At the end of the trial period, your selected plan will be automatically renewed.
If you cancel during the trial, you can still access all Plus features until the trial expires. Additionally, planting real trees with coins is not supported during the trial period.

### Renewal & Billing
Your subscription will renew automatically for the same period. However, if you cancel at least 24 hours before your next renewal date, you won’t be charged for the next billing cycle.
You can cancel anytime via the app store. After cancellation, you’ll still have access to Plus features until the subscription expires.

</div>`)
};

const ar_subscription_detail_page_content_global = /** @type {(inputs: Subscription_Detail_Page_Content_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# مجموعة اشجار متنوعة من بلس

- وصول غير محدود إلى أشجار حصرية من بلس وأشجار موسمية جديدة وأشجار كريستالية موسمية مختارة خلال فترة اشتراكك. (غير مفتوح بشكل دائم)
- أشجار حصرية من بلس محجوزة حصريًا لأعضاء بلس.
- تحديثات المحتوى الموسمية تتم في ٣١ ديسمبر، ٣١ مارس، ٣٠ يونيو، و ٣٠ سبتمبر (UTC+8)، بما في ذلك أشجار موسمية جديدة وأشجار كريستالية موسمية مختارة.
- يمكن استخدام جميع الأشجار في "ازرعوا معًا."

</div>

<div>

# ميزات متقدمة إضافية

|  | مجاني | احترافي | بلس |
| --- | --- | --- | --- |
| مؤقت التركيز | ✔️ | ✔️ | ✔️ |
| إحصائيات المدة | ✔️ | ✔️ | ✔️ |
| ازرعوا معًا | ✔️ | ✔️ | ✔️ |
| وضع التركيز العميق | ✔️ | ✔️ | ✔️ |
| تطبيق مخصص قائمة السماح | - | ✔️ | ✔️ |
| إزالة الإعلانات | - | ✔️ | ✔️ |
| تحليل اتجاه التركيز | - | ✔️ | ✔️ |
| ازرع أشجارًا حقيقية* | - | ✔️ | ✔️ |
| علامات التركيز المخصصة | - | ✔️ | ✔️ |
| بدء الجلسة التالية تلقائيًا | - | ✔️ | ✔️ |
| عملة التركيز 3x | - | - | ✔️ |
| نَمِّى أشجار حصرية من بلس | - | - | ✔️ |
| استمتع بأشجار جديدة في كل موسم | - | - | ✔️ |
| استمتع بـ أشجار كريستالية موسمية مختارة | - | - | ✔️ |
| [حارس الوقت] احظر المزيد من التطبيقات المُشتِّتة | - | - | ✔️ |
| [مساحة اليقظة] استمتع بمجموعة متنوعة من منظر صوتي | - | - | ✔️ |

* *الحد الأقصى لزراعة الأشجار الحقيقية هو 5.

- يشمل مستخدمو نسخة المحترفين مستخدمي iOS الذين دفعوا مقابل تنزيل Forest من متجر آبل، بالإضافة إلى مستخدمي آندرويد الذين قاموا بفتح نسخة المحترفين. 
 - بالنسبة لمستخدمي نسخة المحترفين، سيتم الاحتفاظ بجميع ميزات وفوائد نسخة المحترفين التي تم فتحها في الأصل مدى الحياة، بغض النظر عن حالة الاشتراك.

</div>

<div>

# تذكيرات الاشتراك 

### تفاصيل الفترة التجريبية 
في نهاية الفترة التجريبية، سيتم تجديد الخطة المحددة تلقائيًا. 
إذا قمت بالإلغاء أثناء الفترة التجريبية، فلا يزال بإمكانك الوصول إلى جميع ميزات بلس حتى انتهاء الفترة التجريبية. بالإضافة إلى ذلك، لا يتم دعم زراعة الأشجار الحقيقية بالعملات المعدنية خلال الفترة التجريبية.

### التجديد والفواتير 
سيتم تجديد اشتراكك تلقائيًا لنفس الفترة. ومع ذلك، إذا قمت بالإلغاء قبل 24 ساعة على الأقل من تاريخ التجديد التالي، فلن يتم تحصيل رسوم دورة الفواتير التالية منك. 
يمكنك الإلغاء في أي وقت عبر متجر التطبيقات. بعد الإلغاء، لا يزال بإمكانك الوصول إلى ميزات بلس حتى انتهاء صلاحية الاشتراك.

</div>`)
};

const de_subscription_detail_page_content_global = /** @type {(inputs: Subscription_Detail_Page_Content_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Baumkollektion

- Unbegrenzter Zugang zu Plus Exklusive Bäume, Neue Bäume der Saison und Saisonal ausgewählte Kristallbäume während Ihres Abonnements. (nicht dauerhaft freigeschaltet)
- Plus Exklusive Bäume ist ausschließlich Plus-Mitgliedern vorbehalten.
- Saisonale Inhaltsupdates erfolgen am 31. Dez., 31. März, 30. Juni und 30. Sept. (UTC+8), einschließlich Neue Bäume der Saison und Saisonal ausgewählte Kristallbäume.
- Alle Bäume können in "Gemeinsam pflanzen" verwendet werden.

</div>

<div>

# Plus Erweiterte Funktionen

|  | Kostenlos | Pro | Plus |
| --- | --- | --- | --- |
| Fokus-Timer | ✔️ | ✔️ | ✔️ |
| Dauerstatistik | ✔️ | ✔️ | ✔️ |
| Gemeinsam pflanzen | ✔️ | ✔️ | ✔️ |
| Deep-Focus-Modus | ✔️ | ✔️ | ✔️ |
| Benutzerdefinierte App Liste zulassen | - | ✔️ | ✔️ |
| Anzeigen entfernen | - | ✔️ | ✔️ |
| Schwerpunkt Trendanalyse | - | ✔️ | ✔️ |
| Echte Bäume pflanzen* | - | ✔️ | ✔️ |
| Benutzerdefinierte Fokus-Tags | - | ✔️ | ✔️ |
| Automatischer Start der nächsten Sitzung | - | ✔️ | ✔️ |
| 3x Fokusmünze | - | - | ✔️ |
| Genieße exklusive Plus-Bäume | - | - | ✔️ |
| Versuchen Sie zuerst Neue Bäume der Saison | - | - | ✔️ |
| Genießen Sie Saisonal ausgewählte Kristallbäume | - | - | ✔️ |
| [Zeitwächter] Blockieren Sie mehr unterbrechende Apps | - | - | ✔️ |
| [Achtsamer Raum] Genießen Sie verschiedene Klanglandschaft | - | - | ✔️ |

* *Maximal 5 echte Bäume können gepflanzt werden.

- Pro-Nutzer sind iOS-Nutzer, die für den Download von Forest aus dem App Store bezahlt haben, sowie Android-Nutzer, die die Pro-Version freigeschaltet haben. 
- Für Pro-Nutzer bleiben alle Pro-Funktionen und Vorteile, die ursprünglich freigeschaltet wurden, lebenslang erhalten, unabhängig vom Abonnementstatus.

</div>

<div>

# Abonnement-Erinnerungen

### Details zur Probezeit
Am Ende des Testzeitraums wird das von Ihnen gewählte Abonnement automatisch verlängert.
Wenn Sie während des Testzeitraums kündigen, können Sie bis zum Ablauf des Testzeitraums weiterhin auf alle Plus-Funktionen zugreifen. Außerdem wird das Pflanzen echter Bäume mit Münzen während des Probezeitraums nicht unterstützt.

### Verlängerung & Abrechnung
Ihr Abonnement verlängert sich automatisch um den gleichen Zeitraum. Wenn Sie jedoch mindestens 24 Stunden vor dem nächsten Verlängerungsdatum kündigen, werden Ihnen die Kosten für den nächsten Abrechnungszyklus nicht in Rechnung gestellt.
Sie können jederzeit über den App-Store kündigen. Nach der Kündigung haben Sie weiterhin Zugang zu den Plus-Funktionen, bis das Abonnement abläuft.

</div>`)
};

const es_subscription_detail_page_content_global = /** @type {(inputs: Subscription_Detail_Page_Content_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Colección de árboles Plus

- Acceso ilimitado a Árboles exclusivos Plus y Árboles de cristal de temporada seleccionados durante tu suscripción. (no desbloqueado permanentemente)
- Los Árboles exclusivos Plus están estrictamente reservados para los miembros Plus.
- Actualizaciones de contenido estacionales cada 31 de dic., 31 de mar., 30 de jun. y 30 de sep. (UTC+8), incluyendo Nuevos árboles de temporada y Árboles de cristal de temporada seleccionados.
- Todos los árboles se pueden utilizar en el modo Plantar juntos.

</div>

<div>

# Funciones avanzadas de Plus

|  | Gratis | Pro | Plus |
| --- | --- | --- | --- |
| Temporizador de concentración | ✔️ | ✔️ | ✔️ |
| Estadísticas de duración | ✔️ | ✔️ | ✔️ |
| Plantar juntos | ✔️ | ✔️ | ✔️ |
| Modo de concentración profunda | ✔️ | ✔️ | ✔️ |
| Lista personalizada de apps permitidas | - | ✔️ | ✔️ |
| Elimina los anuncios | - | ✔️ | ✔️ |
| Análisis de tendencias de concentración | - | ✔️ | ✔️ |
| Planta árboles reales* | - | ✔️ | ✔️ |
| Etiquetas de concentración personalizadas | - | ✔️ | ✔️ |
| Inicio automático de la siguiente sesión | - | ✔️ | ✔️ |
| Moneda de concentración x3 | - | - | ✔️ |
| Disfruta de los Árboles exclusivos Plus | - | - | ✔️ |
| Prueba los Nuevos árboles de temporada primero | - | - | ✔️ |
| Disfruta los Árboles de cristal de temporada seleccionados | - | - | ✔️ |
| [Guardián del Tiempo] Bloquea las apps más intrusivas | - | - | ✔️ |
| [Espacio consciente] Disfruta de diversos paisajes sonoros | - | - | ✔️ |

* *El límite máximo para plantar árboles reales es de 5.

- Entre los usuarios de Pro se incluyen los usuarios de iOS que hayan pagado para descargar Forest de la App Store, así como los usuarios de Android que hayan desbloqueado la versión Pro. 
- Para los usuarios de Pro, todas las características y beneficios Pro que fueron desbloqueados originalmente se mantendrán de por vida, independientemente del estado de suscripción.

</div>

<div>

# Recordatorios de suscripción

### Detalles del periodo de prueba
Al final del periodo de prueba, el plan seleccionado se renovará automáticamente.
Si cancelas durante el periodo de prueba, podrás seguir accediendo a todas las funciones Plus hasta que caduque este periodo. Además, la función de plantar árboles reales con monedas no está disponible durante el periodo de prueba.

### Renovación y facturación
Tu suscripción se renovará automáticamente por el mismo periodo. Sin embargo, si la cancelas al menos 24 horas antes de la siguiente fecha de renovación, no se te cobrará el siguiente ciclo de facturación.
Puedes cancelar en cualquier momento a través de la tienda de aplicaciones. Tras la cancelación, seguirás teniendo acceso a las funciones Plus hasta que caduque la suscripción.

</div>`)
};

const fr_subscription_detail_page_content_global = /** @type {(inputs: Subscription_Detail_Page_Content_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Collection d'arbres Plus

- Accès illimité aux Arbres exclusifs Plus, Nouveaux arbres saisonniers et Arbres premium de saison pendant votre abonnement (non débloqués de façon permanente).
- Les Arbres exclusifs Plus sont exclusivement réservés aux membres Plus.
- Nouveautés saisonnières mises à jour les 31 déc., 31 mars, 30 juin et 30 sept. (UTC+8), incluant les Nouveaux arbres saisonniers et Arbres premium de saison.
- Tous les arbres peuvent être utilisés dans « Planter ensemble ».

</div>

<div>

# Fonctionnalités Avancées Plus

|  | Gratuit | Pro | Plus |
| --- | --- | --- | --- |
| Minuteur de concentration | ✔️ | ✔️ | ✔️ |
| Statistiques de durée | ✔️ | ✔️ | ✔️ |
| Planter Ensemble | ✔️ | ✔️ | ✔️ |
| Mode Concentration Profonde | ✔️ | ✔️ | ✔️ |
| Liste des autorisations personnalisée | - | ✔️ | ✔️ |
| Supprimer les publicités | - | ✔️ | ✔️ |
| Analyse des tendances de concentration | - | ✔️ | ✔️ |
| Plantez de véritables arbres* | - | ✔️ | ✔️ |
| Tags personnalisables | - | ✔️ | ✔️ |
| Démarrage automatique de la prochaine session | - | ✔️ | ✔️ |
| Triplez vos pièces obtenues | - | - | ✔️ |
| Profitez des arbres exclusifs Plus | - | - | ✔️ |
| Essayez les Nouveaux arbres saisonniers en premier | - | - | ✔️ |
| Profitez d'Arbres premium de saison | - | - | ✔️ |
| [Gardien du Temps] Bloquer plus d'applications dérangeantes | - | - | ✔️ |
| [Espace de relaxation] Profitez d'une multitude de Paysages sonores | - | - | ✔️ |

* *Vous pouvez planter jusqu’à 5 vrais arbres.

- Les utilisateurs Pro comprennent les utilisateurs iOS qui ont payé pour télécharger Forest depuis l'App Store, ainsi que les utilisateurs Android qui ont débloqué la version Pro.
- Pour les utilisateurs Pro, toutes les fonctionnalités et avantages Pro initialement débloqués sont conservés à vie, quel que soit le statut de l'abonnement.

</div>

<div>

# Rappels concernant votre abonnement

### À propos de votre période d'essai
À la fin de votre période d'essai, le forfait que vous avez choisi sera automatiquement renouvelé.
Si vous décidez d'annuler pendant l'essai, vous pourrez continuer à profiter de toutes les fonctionnalités Plus jusqu'à son expiration. De plus, la plantation de vrais arbres avec des pièces n'est pas disponible pendant la période d'essai.

### Renouvellement et facturation
Votre abonnement se renouvelle automatiquement pour la même durée. Cependant, si vous souhaitez l'annuler, faites-le au moins 24 heures avant la date de renouvellement pour éviter toute facturation pour le cycle suivant.
Vous pouvez annuler à tout moment via la boutique d’applications. Après l'annulation, vous conserverez l'accès à tous les avantages Plus jusqu'à l'expiration de votre abonnement.

</div>`)
};

const it_subscription_detail_page_content_global = /** @type {(inputs: Subscription_Detail_Page_Content_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Collezione alberi Plus

- Accesso illimitato a Alberi esclusivi Plus, Nuovi alberi stagionali, e Selezione stagionale degli alberi di cristalli durante il tuo abbonamento. (non sbloccato in modo permanente)
- Alberi esclusivi Plus sono strettamente riservati ai membri Plus.
- Aggiornamenti stagionali dei contenuti ogni 31 dic, 31 mar, 30 giu e 30 set (UTC+8), inclusi Nuovi alberi stagionali, e Selezione stagionale degli alberi di cristalli.
- Tutti gli alberi possono essere utilizzati in "Pianta in gruppo."

</div>

<div>

# Funzionalità Plus Avanzate

|  | Gratis | Pro | Plus |
| --- | --- | --- | --- |
| Timer di concentrazione | ✔️ | ✔️ | ✔️ |
| Statistiche sulla durata | ✔️ | ✔️ | ✔️ |
| Pianta in gruppo | ✔️ | ✔️ | ✔️ |
| Modalità Concentrazione Intensiva | ✔️ | ✔️ | ✔️ |
| Lista App Consentite personalizzata | - | ✔️ | ✔️ |
| Rimuovi annunci | - | ✔️ | ✔️ |
| Analisi del trend di concentrazione | - | ✔️ | ✔️ |
| Pianta alberi veri* | - | ✔️ | ✔️ |
| Tag personalizzati | - | ✔️ | ✔️ |
| Avvio automatico della sessione successiva | - | ✔️ | ✔️ |
| 3x monete di concentrazione | - | - | ✔️ |
| Goditi gli alberi esclusivi Plus | - | - | ✔️ |
| Prova prima gli Nuovi alberi stagionali | - | - | ✔️ |
| Goditi la Selezione stagionale degli alberi di cristalli | - | - | ✔️ |
| [Time Guard] Blocca più app interruttive | - | - | ✔️ |
| [Spazio Mindful] Goditi vari Soundscape | - | - | ✔️ |

* *Il limite massimo di alberi veri piantabili è 5.

- Gli Utenti Pro includono gli utenti iOS che hanno pagato per scaricare Forest dall'App Store, così come gli utenti Android che hanno sbloccato la versione Pro. 
- Per gli Utenti Pro, tutte le funzionalità e i vantaggi Pro originariamente sbloccati verranno mantenuti a vita, indipendentemente dallo stato dell'abbonamento.

</div>

<div>

# Promemoria per l'Abbonamento

### Dettagli sul periodo di prova
Al termine del periodo di prova, il piano selezionato verrà rinnovato automaticamente.
Se annulli l'abbonamento durante il periodo di prova, puoi comunque accedere a tutte le funzionalità Plus fino alla scadenza del periodo di prova. Inoltre, piantare alberi veri con le monete non è supportato durante il periodo di prova.

### Rinnovo e fatturazione
L'abbonamento si rinnoverà automaticamente per lo stesso periodo. Tuttavia, se annulli almeno 24 ore prima della data di rinnovo successiva, non ti verrà addebitato alcun costo per il ciclo di fatturazione successivo.
Puoi annullare in qualsiasi momento tramite lo store di applicazioni. Dopo l'annullamento, avrai ancora accesso alle funzionalità Plus fino alla scadenza dell'abbonamento.

</div>`)
};

const ja_subscription_detail_page_content_global = /** @type {(inputs: Subscription_Detail_Page_Content_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plusツリーコレクション

- サブスクリプション期間中、Plus限定の木、シーズン限定の新しい木、シーズン限定クリスタルツリーを無制限で利用できます（※永久アンロックではありません）。
- Plus限定の木は、Plusメンバー専用です。
- シーズンコンテンツは、毎年12月31日、3月31日、6月30日、9月30日 (UTC+8)に更新されます（シーズン限定の新しい木、シーズン限定クリスタルツリーを含む）。
- すべての木は「一緒に植える」モードで使用できます。

</div>

<div>

# Plusの高度な機能

|  | 無料 | Pro | Plus |
| --- | --- | --- | --- |
| フォーカスタイマー | ✔️ | ✔️ | ✔️ |
| 期間統計 | ✔️ | ✔️ | ✔️ |
| 一緒に植える | ✔️ | ✔️ | ✔️ |
| ディープフォーカスモード | ✔️ | ✔️ | ✔️ |
| アプリの許可リストのカスタマイズ | - | ✔️ | ✔️ |
| 広告の削除 | - | ✔️ | ✔️ |
| 集中傾向の分析 | - | ✔️ | ✔️ |
| 本物の木を植える* | - | ✔️ | ✔️ |
| フォーカスタグのカスタマイズ | - | ✔️ | ✔️ |
| 次のセッションを自動開始 | - | ✔️ | ✔️ |
| 獲得コイン3倍 | - | - | ✔️ |
| Plus限定の木を楽しもう | - | - | ✔️ |
| シーズン限定の新しい木を先行お試し | - | - | ✔️ |
| シーズン限定クリスタルツリーを楽しむ | - | - | ✔️ |
| [タイムガード] 邪魔なアプリをさらにブロック | - | - | ✔️ |
| [森のリトリート] さまざまなサウンドスケープ | - | - | ✔️ |

* *植えられる本物の木は最大5本です。

- プロユーザーには、App StoreからForestを有料でダウンロードしたiOSユーザーと、プロ版をアンロックしたAndroidユーザーが含まれます。 
- プロユーザーの場合、サブスクリプションのステータスに関係なく、最初にアンロックされたすべてのプロ機能と特典は生涯ご利用いただけます。

</div>

<div>

# サブスクリプションに関する注意点

### トライアル期間の詳細
トライアル期間終了時に、選択したプランが自動的に更新されます。
トライアル期間中にキャンセルした場合でも、トライアル期間が終了するまですべてのPlus機能をご利用いただけます。また、トライアル期間中はコインを使った本物の木の植樹機能はご利用いただけません。

### 更新と請求
サブスクリプションは同じ期間自動的に更新されます。ただし、次の更新日の24時間前までにキャンセルした場合、次の請求サイクルに対して請求されることはありません。
アプリストアからいつでもキャンセルできます。キャンセル後も、サブスクリプションの有効期限が切れるまでPlus機能をご利用いただけます。

</div>`)
};

const ko_subscription_detail_page_content_global = /** @type {(inputs: Subscription_Detail_Page_Content_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus 나무 컬렉션

- 구독 기간 동안 Plus 전용 나무, 시즌별 신규 나무, 시즌별 엄선된 크리스탈 나무 무제한 액세스 지원. (기간제)
- Plus 전용 나무는 Plus 회원 전용이에요.
- 시즌별 신규 나무, 시즌별 엄선된 크리스탈 나무 등 매년 12월 31일, 3월 31일, 6월 30일, 9월 30일(UTC+8)에 시즌 콘텐츠가 업데이트돼요.
- 모든 나무는 "함께 심기"에서 심을 수 있어요.

</div>

<div>

# Plus 고급 기능

|  | 무료 | Pro | Plus |
| --- | --- | --- | --- |
| 집중 타이머 | ✔️ | ✔️ | ✔️ |
| 기간 통계 | ✔️ | ✔️ | ✔️ |
| 함께 심기 | ✔️ | ✔️ | ✔️ |
| 딥 포커스 모드 | ✔️ | ✔️ | ✔️ |
| 커스텀 앱 앱 허용 리스트 | - | ✔️ | ✔️ |
| 광고 제거 | - | ✔️ | ✔️ |
| 집중 추세 분석 | - | ✔️ | ✔️ |
| 실제 나무 기부하기* | - | ✔️ | ✔️ |
| 사용자 지정 포커스 태그 | - | ✔️ | ✔️ |
| 다음 세션 자동 시작 | - | ✔️ | ✔️ |
| 포커스 코인 3배 획득 | - | - | ✔️ |
| Plus 전용 나무를 즐겨보세요 | - | - | ✔️ |
| 누구보다 먼저 시즌별 신규 나무를 만나세요 | - | - | ✔️ |
| 시즌별 엄선된 크리스탈 나무를 만나보세요 | - | - | ✔️ |
| [타임 가드] 방해되는 앱 차단 한도 증가 | - | - | ✔️ |
| [마음챙김 공간] 다양한 사운드스케이프 지원 | - | - | ✔️ |

* *심을 수 있는 실제 나무는 최대 5그루입니다.

- Pro 사용자에는 앱 스토어에서 유료로 Forest를 다운로드한 iOS 사용자와 Pro 버전을 구입한 Android 사용자가 포함됩니다. 
- Pro 사용자의 경우, 기존에 구입한 모든 Pro 기능 및 혜택은 구독 상태와 관계없이 평생 유지됩니다.

</div>

<div>

# 구독 알림

### 체험판 기간 세부 정보
체험 기간이 끝나면 선택한 플랜이 자동으로 갱신돼요.
체험 기간 도중에 취소해도 체험판이 끝날 때까지 모든 Plus 기능을 계속 이용할 수 있어요. 또한, 체험 기간 중에는 코인으로 실제 나무를 심는 기능이 지원되지 않아요.

### 갱신 및 결제
구독은 동일 기간으로 자동 갱신돼요. 그러나 다음 갱신 날짜 최소 24시간 전에 취소하면 다음 결제 기간에 대한 요금이 청구되지 않아요.
언제든지 앱 스토어에서 구독을 취소할 수 있어요. 취소 후에도 구독이 만료될 때까지 Plus 기능을 계속 이용할 수 있어요.

</div>`)
};

const pt_br_subscription_detail_page_content_global = /** @type {(inputs: Subscription_Detail_Page_Content_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Coleção de árvores Plus

- Acesso ilimitado a Árvores exclusivas Plus, Novas árvores sazonais e Árvores sazonais de Cristais do Tempo durante sua assinatura (não fica desbloqueado permanentemente).
- As Árvores exclusivas Plus são estritamente reservadas para os membros Plus.
- O conteúdo sazonal é atualizado sempre em 31/12, 31/03, 30/06 e 30/09 (UTC+8), incluindo Novas árvores sazonais e Árvores sazonais de Cristais do Tempo.
- Todas as árvores podem ser usadas no modo "Plantar juntos".

</div>

<div>

# Funcionalidades avançadas Plus

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Temporizador de foco | ✔️ | ✔️ | ✔️ |
| Estatísticas de duração | ✔️ | ✔️ | ✔️ |
| Plantar juntos | ✔️ | ✔️ | ✔️ |
| Modo Foco Total | ✔️ | ✔️ | ✔️ |
| Lista de permissões personalizada | - | ✔️ | ✔️ |
| Remoção de anúncios | - | ✔️ | ✔️ |
| Análise das tendências de foco | - | ✔️ | ✔️ |
| Plante árvores reais* | - | ✔️ | ✔️ |
| Tags de foco personalizadas | - | ✔️ | ✔️ |
| Início automático da próxima sessão | - | ✔️ | ✔️ |
| 3x mais moedas | - | - | ✔️ |
| Aproveite Árvores exclusivas Plus | - | - | ✔️ |
| Experimente as Novas árvores sazonais primeiro | - | - | ✔️ |
| Aproveite as Árvores sazonais de Cristais do Tempo | - | - | ✔️ |
| [Vigia do Tempo] Bloqueie os aplicativos que mais te interrompem | - | - | ✔️ |
| [Espaço Consciente] Aproveite várias paisagens sonoras | - | - | ✔️ |

* *O limite máximo para plantar árvores reais é 5.

- Usuários Pro incluem os usuários iOS que pagaram para baixar o Forest na App Store, assim como os usuários Android que desbloquearam a versão Pro.
- Para os usuários Pro, todas as funcionalidades e benefícios Pro que foram originalmente desbloqueados serão mantidos para sempre, independentemente do status da assinatura.

</div>

<div>

# Lembretes sobre a assinatura

### Detalhes do período de teste
No final do período de teste, o plano selecionado será renovado automaticamente.
Se efetuar o cancelamento durante o período de teste, você ainda terá acesso a todas as funcionalidades Plus até a data de expiração do teste grátis. Além disso, o plantio de árvores reais com moedas não é suportado durante o período de teste.

### Renovação e cobrança
Sua assinatura será renovada automaticamente pelo mesmo período. No entanto, se você efetuar o cancelamento com pelo menos 24 horas de antecedência da próxima data de renovação, a fatura do próximo ciclo não será cobrada.
Você pode efetuar o cancelamento a qualquer momento pela loja de aplicativos. Após o cancelamento, você ainda terá acesso aos recursos Plus até a data de expiração da assinatura.

</div>`)
};

const ru_subscription_detail_page_content_global = /** @type {(inputs: Subscription_Detail_Page_Content_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Коллекция деревьев Plus

- Неограниченный доступ к Эксклюзивным деревьям Plus, Новым сезонным деревьям и Сезонным кристальным деревьям на выбор на время действия подписки (не является разблокировкой навсегда).
- Эксклюзивные деревья Plus доступны только пользователям Plus.
- Сезонный контент обновляется 31 декабря, 31 марта, 30 июня и 30 сентября (UTC+8), включая Новые сезонные деревья и Сезонные кристальные деревья на выбор.
- Все деревья можно использовать с функцией «Сажать вместе».

</div>

<div>

# Продвинутые Plus-функции

|  | Бесплатно | Pro | Plus |
| --- | --- | --- | --- |
| Таймер фокусировки | ✔️ | ✔️ | ✔️ |
| Статистика продолжительности | ✔️ | ✔️ | ✔️ |
| Сажать вместе | ✔️ | ✔️ | ✔️ |
| Режим глубокой фокусировки | ✔️ | ✔️ | ✔️ |
| Настраиваемый Список разрешений приложений | - | ✔️ | ✔️ |
| Удаление рекламы | - | ✔️ | ✔️ |
| Анализ тенденций фокусировки | - | ✔️ | ✔️ |
| Сажайте настоящие деревья* | - | ✔️ | ✔️ |
| Пользовательские теги фокуса | - | ✔️ | ✔️ |
| Автозапуск следующей сессии | - | ✔️ | ✔️ |
| в 3 раза больше монет за фокусировку | - | - | ✔️ |
| Наслаждайтесь эксклюзивными деревьями Plus | - | - | ✔️ |
| Попробуйте Новые сезонные деревья первым | - | - | ✔️ |
| Наслаждайтесь сезонными кристальными деревьями на выбор | - | - | ✔️ |
| [Контроль времени] Блокируйте больше отвлекающих приложений | - | - | ✔️ |
| [Пространство осознанности] Наслаждайтесь различными звуковыми ландшафтами | - | - | ✔️ |

* *Максимум можно посадить 5 настоящих деревьев.

- К пользователям Pro относятся пользователи iOS, оплатившие скачивание Forest из App Store, а также пользователи Android, разблокировавшие версию Pro. 
- Для пользователей Pro все функции и преимущества Pro, которые были изначально разблокированы, сохраняются навсегда, независимо от статуса подписки.

</div>

<div>

# Напоминания о подписке

### Подробности пробного периода
По окончании пробного периода выбранный вами тарифный план будет автоматически продлен.
Если вы отмените подписку во время пробного периода, вы всё ещё сможете пользоваться всеми функциями Plus до истечения срока действия пробного периода. Кроме того, посадка настоящих деревьев за монеты не поддерживается в течение пробного периода.

### Продление и выставление счёта
Ваша подписка будет продлена автоматически на тот же период. Однако если вы отмените подписку не позднее чем за 24 часа до даты следующего продления, плата за следующий расчетный цикл с вас снята не будет.
Вы можете отменить подписку в любое время через магазин приложений. После отмены подписки у вас всё ещё будет доступ к функциям Plus до истечения срока действия подписки.

</div>`)
};

const th_subscription_detail_page_content_global = /** @type {(inputs: Subscription_Detail_Page_Content_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# คอลเล็กชันต้นไม้สำหรับ Plus

- เข้าถึงต้นไม้สุดพิเศษสำหรับ Plus ต้นไม้ใหม่ประจำฤดูกาล และต้นไม้คริสตัลที่คัดสรรตามฤดูกาลอย่างไม่จำกัดตลอดการสมัครสมาชิกของคุณ (ไม่ได้ปลดล็อกถาวร)
- ต้นไม้สุดพิเศษสำหรับ Plus เปิดให้ใช้งานเฉพาะสมาชิก Plus เท่านั้น
- เนื้อหาตามฤดูกาลจะมีการอัปเดตทุกวันที่ 31 ธ.ค., 31 มี.ค., 30 มิ.ย., และ 30 ก.ย. (UTC+8) โดยรวมถึงต้นไม้ใหม่ประจำฤดูกาลและต้นไม้คริสตัลที่คัดสรรตามฤดูกาล
- ต้นไม้ทั้งหมดสามารถใช้งานได้ใน "ปลูกต้นไม้ด้วยกัน"

</div>

<div>

# คุณสมบัติขั้นสูงของ Plus

|  | ฟรี | โปร | Plus |
| --- | --- | --- | --- |
| ตัวจับเวลาการโฟกัส | ✔️ | ✔️ | ✔️ |
| สถิติระยะเวลา | ✔️ | ✔️ | ✔️ |
| ปลูกต้นไม้ด้วยกัน | ✔️ | ✔️ | ✔️ |
| โหมดโฟกัสเต็มที่ | ✔️ | ✔️ | ✔️ |
| รายการอนุญาตแอปที่กำหนดเอง | - | ✔️ | ✔️ |
| ลบโฆษณา | - | ✔️ | ✔️ |
| การวิเคราะห์เทรนด์การโฟกัส | - | ✔️ | ✔️ |
| ปลูกต้นไม้จริง* | - | ✔️ | ✔️ |
| แท็กการโฟกัสที่กำหนดเอง | - | ✔️ | ✔️ |
| เริ่มเซสชันถัดไปอัตโนมัติ | - | ✔️ | ✔️ |
| เหรียญการโฟกัส 3 เท่า | - | - | ✔️ |
| เพลิดเพลินกับต้นไม้สุดพิเศษสำหรับ Plus | - | - | ✔️ |
| ลองปลูกต้นไม้ใหม่ประจำฤดูกาลก่อนใคร | - | - | ✔️ |
| เพลิดเพลินกับต้นไม้คริสตัลที่คัดสรรตามฤดูกาล | - | - | ✔️ |
| [การปกป้องเวลา] บล็อกแอปที่รบกวนได้มากขึ้น | - | - | ✔️ |
| [พื้นที่ฝึกสติ] เพลิดเพลินกับทัศนียภาพแห่งเสียงที่หลากหลาย | - | - | ✔️ |

* *ขีดจำกัดสูงสุดในการปลูกต้นไม้จริงคือ 5 ต้น

- ผู้ใช้โปรได้แก่ ผู้ใช้ iOS ที่ชำระเงินเพื่อดาวน์โหลด Forest จาก App Store รวมถึงผู้ใช้ Android ที่ปลดล็อกเวอร์ชันโปรแล้ว
- สำหรับผู้ใช้โปร คุณสมบัติและสิทธิประโยชน์โปรทั้งหมดที่ถูกปลดล็อกตั้งแต่เดิมจะคงอยู่ตลอดชีพ ไม่ว่าสถานะการสมัครสมาชิกจะเป็นแบบใดก็ตาม

</div>

<div>

# การแจ้งเตือนการสมัครสมาชิก

### รายละเอียดช่วงทดลองใช้งาน
เมื่อช่วงทดลองใช้งานสิ้นสุดลง แผนที่คุณเลือกไว้จะถูกต่ออายุโดยอัตโนมัติ
หากคุณทำการยกเลิกระหว่างช่วงทดลองใช้งาน คุณยังสามารถเข้าถึงคุณสมบัติ Plus ทั้งหมดได้จนกว่าช่วงทดลองใช้งานจะหมดอายุ นอกจากนี้ ฟีเจอร์การปลูกต้นไม้จริงด้วยเหรียญจะไม่รองรับในช่วงทดลองใช้งาน

### การต่ออายุและการเรียกเก็บเงิน
การสมัครสมาชิกของคุณจะต่ออายุโดยอัตโนมัติในช่วงเวลาเดียวกัน อย่างไรก็ตาม หากคุณทำการยกเลิกก่อนวันต่ออายุครั้งถัดไปอย่างน้อย 24 ชั่วโมง คุณจะไม่ถูกเรียกเก็บเงินสำหรับรอบการเรียกเก็บเงินครั้งถัดไป
คุณสามารถยกเลิกได้ตลอดเวลาผ่านร้านแอปพลิเคชัน หลังจากที่ยกเลิกแล้ว คุณจะยังคงสามารถเข้าถึงคุณสมบัติ Plus ได้จนกว่าการสมัครสมาชิกจะหมดอายุ

</div>`)
};

const tr_subscription_detail_page_content_global = /** @type {(inputs: Subscription_Detail_Page_Content_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Mevsimsel İçerikPlus Ağaç Koleksiyonu

- Aboneliğin süresince Plus Özel Ağaçlar, Mevsimsel Yeni Ağaçlar ve Mevsimsel Seçkin Kristal Ağaçlara sınırsız erişim (kilitleri kalıcı olarak açılmaz)
- Plus Özel Ağaçlar, yalnızca Plus üyeleri için ayrılmıştır.
- Mevsimsel Yeni Ağaçlar ve Mevsimsel Seçkin Kristal Ağaçlar dahil olmak üzere her 31 Aralık, 31 Mart, 30 Haziran ve 30 Eylül'de (UTC+8) mevsimsel içerik güncellemeleri yapılır.
- Tüm ağaçlar "Birlikte ağaç dikin" modunda kullanılabilir.

</div>

<div>

# Plus Gelişmiş Özellikler

|  | Ücretsiz | Pro | Plus |
| --- | --- | --- | --- |
| Odak Zamanlayıcısı | ✔️ | ✔️ | ✔️ |
| Süre İstatistikleri | ✔️ | ✔️ | ✔️ |
| Birlikte ağaç dikin | ✔️ | ✔️ | ✔️ |
| Derin Odak Modu | ✔️ | ✔️ | ✔️ |
| Özel Uygulama İzin Listesi | - | ✔️ | ✔️ |
| Reklamları Kaldır | - | ✔️ | ✔️ |
| Odaklanma trend analizi | - | ✔️ | ✔️ |
| Gerçek ağaçlar dik* | - | ✔️ | ✔️ |
| Özel Odak Etiketleri | - | ✔️ | ✔️ |
| Sonraki Oturumu Otomatik Başlat | - | ✔️ | ✔️ |
| 3x odaklanma jetonu | - | - | ✔️ |
| Plus’a Özel Ağaçların keyfini çıkarın | - | - | ✔️ |
| Önce Mevsimsel Yeni Ağaçlarını dene | - | - | ✔️ |
| Mevsimsel Seçkin Kristal Ağaçlarnın keyfini çıkar | - | - | ✔️ |
| [Zaman Koruması] Daha fazla rahatsız edici uygulamayı engelle | - | - | ✔️ |
| [Farkındalık Alanı] Çeşitli ses manzaralarının tadını çıkar | - | - | ✔️ |

* *Gerçek ağaç dikmenin azami limiti 5’tir.

- Pro kullanıcıları, Forest'ı App Store'dan indirmek için ödeme yapan iOS kullanıcılarının yanı sıra Pro sürümünün kilidini açan Android kullanıcılarını da içerir. 
- Pro kullanıcılar için başlangıçta kilidi açılmış olan tüm Pro özellikleri ve avantajları, abonelik durumundan bağımsız olarak ömür boyu korunacaktır.

</div>

<div>

# Abonelik Hatırlatmaları

### Deneme Süresi Detayları
Deneme süresinin sonunda, seçtiğin plan otomatik olarak yenilenecektir.
Deneme süresi içinde iptal edersen, deneme süresi sona erene kadar tüm Plus özelliklerine erişmeye devam edebilirsin. Ayrıca, deneme süresi boyunca jetonlarla gerçek ağaç dikme özelliği desteklenmemektedir.

### Yenileme ve Faturalama
Aboneliğin aynı dönem için otomatik olarak yenilenecektir. Ancak aboneliğini bir sonraki yenileme tarihinden en az 24 saat önce iptal edersen bir sonraki faturalandırma döngüsü için ücretlendirilmezsin.
İstediğin zaman uygulama mağazası üzerinden aboneliğini iptal edebilirsin. İptal işleminden sonra, aboneliğin sona erene kadar Plus özelliklerine erişmeye devam edersin.

</div>`)
};

const zh_cn_subscription_detail_page_content_global = /** @type {(inputs: Subscription_Detail_Page_Content_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus 树种阵容

- Plus 会员期间，可无限使用「Plus 限定树」、「当季新树」以及「当季精选宝石树」（非永久解锁）
- Plus 限定树仅保留给 Plus 会员使用
- 季节内容会于每年 12月31日、3月31日、6月30日、9月30日 (UTC+8) 定期更新「当季新树」与「当季精选宝石树」。
- 所有树种皆可用于「多人一起种」模式

</div>

<div>

# Plus 进阶功能

|  | 免费版 | 专业版 | Plus 会员 |
| --- | --- | --- | --- |
| 专注计时 | ✔️ | ✔️ | ✔️ |
| 时长统计 | ✔️ | ✔️ | ✔️ |
| 与好友一起种 | ✔️ | ✔️ | ✔️ |
| 深度专注 | ✔️ | ✔️ | ✔️ |
| 自订软件白名单 | - | ✔️ | ✔️ |
| 无广告 | - | ✔️ | ✔️ |
| 专注趋势分析 | - | ✔️ | ✔️ |
| 为地球种下真树* | - | ✔️ | ✔️ |
| 自订专注标签 | - | ✔️ | ✔️ |
| 自动下一轮专注 | - | ✔️ | ✔️ |
| 专注金币 3 倍 | - | - | ✔️ |
| 独享 Plus 限定树种 | - | - | ✔️ |
| 抢先体验每季最新树种 | - | - | ✔️ |
| 无限使用当季精选宝石树 | - | - | ✔️ |
| [时间守护] 阻挡多个干扰 App | - | - | ✔️ |
| [正念空间] 享受更多声音场景 | - | - | ✔️ |

* *种真树目前上限为 5 棵。

- 专业版用户包含 iOS 有在 App Store 付费下载过 Forest 或是 Android 有解锁专业版的用户
- 专业版用户原先解锁专业版的功能和权益都将终身保留，无论是否有购买 Plus 会员

</div>

<div>

# 权益说明

### Plus 试用权益说明
试用期满后将自动续费所选方案。若试用中取消，你仍可在试用到期日前享有 Plus 内容与功能。另外试用期间不支持金币种植真树功能。

### 续费扣款说明
你的 Plus 会员将会以相同期限自动续费，但只要在下次续费日的 24 小时前取消，就不会收取下一期费用。你可以随时在应用商城取消，取消后仍可在 Plus 会员到期日前享有 Plus 内容与功能。

</div>`)
};

const zh_tw_subscription_detail_page_content_global = /** @type {(inputs: Subscription_Detail_Page_Content_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus 樹種陣容

- 訂閱期間，可無限使用「Plus 限定樹」、「當季新樹」以及「當季精選寶石樹」（非永久解鎖）
- Plus 限定樹僅保留給 Plus 訂閱用戶使用
- 季節內容會於每年 12/31、3/31、6/30、9/30 (UTC+8) 定期更新「當季新樹」與「當季精選寶石樹」。
- 所有樹種皆可用於「多人一起種」模式

</div>

<div>

# Plus 進階功能

|  | 免費版 | 專業版 | 訂閱 Plus |
| --- | --- | --- | --- |
| 專注計時 | ✔️ | ✔️ | ✔️ |
| 時長統計 | ✔️ | ✔️ | ✔️ |
| 一起種 | ✔️ | ✔️ | ✔️ |
| 深度專注 | ✔️ | ✔️ | ✔️ |
| 自訂 App 允許名單 | - | ✔️ | ✔️ |
| 無廣告 | - | ✔️ | ✔️ |
| 專注趨勢分析 | - | ✔️ | ✔️ |
| 為地球種下真樹* | - | ✔️ | ✔️ |
| 自訂專注標籤 | - | ✔️ | ✔️ |
| 自動下一輪專注 | - | ✔️ | ✔️ |
| 專注金幣 3 倍 | - | - | ✔️ |
| 獨享 Plus 限定樹種 | - | - | ✔️ |
| 搶先體驗每季最新樹種 | - | - | ✔️ |
| 無限使用當季精選寶石樹 | - | - | ✔️ |
| [時間守護] 阻擋多個干擾 App | - | - | ✔️ |
| [正念空間] 享受更多聲音場景 | - | - | ✔️ |

* *種真樹目前上限為 5 棵。

- 專業版用戶包含 iOS 有在 App Store 付費下載過 Forest 或是 Android 有解鎖專業版的用戶
- 專業版用戶原先解鎖專業版的功能和權益都將終身保留，無論是否有訂閱

</div>

<div>

# 訂閱權益說明

### 試用權益說明
試用期滿後將自動續訂所選方案。若試用中取消，你仍可在試用到期日前享有 Plus 內容與功能。另外試用期間不支援金幣種植真樹功能。

### 續訂扣款說明
你的訂閱將會以相同期限自動續約，但只要在下次續約日的 24 小時前取消，就不會收取下一期費用。你可以隨時在應用商店取消，取消後仍可在訂閱到期日前享有 Plus 內容與功能。

</div>`)
};

/**
* | output |
* | --- |
* | "<div> # Plus Tree Collection - Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your subscription. (not..." |
*
* @param {Subscription_Detail_Page_Content_GlobalInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_detail_page_content_global = /** @type {((inputs?: Subscription_Detail_Page_Content_GlobalInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Detail_Page_Content_GlobalInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_detail_page_content_global(inputs)
	if (locale === "ar") return ar_subscription_detail_page_content_global(inputs)
	if (locale === "de") return de_subscription_detail_page_content_global(inputs)
	if (locale === "es") return es_subscription_detail_page_content_global(inputs)
	if (locale === "fr") return fr_subscription_detail_page_content_global(inputs)
	if (locale === "it") return it_subscription_detail_page_content_global(inputs)
	if (locale === "ja") return ja_subscription_detail_page_content_global(inputs)
	if (locale === "ko") return ko_subscription_detail_page_content_global(inputs)
	if (locale === "pt_br") return pt_br_subscription_detail_page_content_global(inputs)
	if (locale === "ru") return ru_subscription_detail_page_content_global(inputs)
	if (locale === "th") return th_subscription_detail_page_content_global(inputs)
	if (locale === "tr") return tr_subscription_detail_page_content_global(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_detail_page_content_global(inputs)
	return zh_tw_subscription_detail_page_content_global(inputs)
});